import emailRegex from "./emailRegex";

export const formErrorsMessage = {
  signup: {
    firstName: "First name is not valid",
    lastName: "Last name is not valid",
    mobileNumber: "Mobile number is not valid",
    password: "Password is not valid",
    email: "Email is not valid",
    newPassword: "Password is not valid",
    currentPassword: "Password is not valid"
  },
  login: {
    password: "Password is not valid",
    email: "Email is not valid"
  },
  facebook: {
    password: "Password is not valid",
    email: "Email is not valid",
    mobileNumber: "Mobile number is not valid"
  },
  forgotPass: {
    email: "Email is not valid"
  },
  restorePass: {
    password: "Password is not valid",
    confirmPassword: "Password is not valid"
  },
  addPayment: {
    holderName: "Holder name is not valid",
    expYear: "Expiry year must be between 2018 and 2030",
    expMonth: "Expiry month must be between 1 and 12",
    number: "Credit card number should be 16 digits",
    cvv2: "Cvv2 number is incorrect"
  },
  submitAddress: {
    postalCode: "Postal code is required",
    addressLine1: "Address Line 1 is required",
    flatNumber: "Flat number is required"
  },
  joinUs: {
    restaurantName: "Restaurant name is not valid",
    postalCode: "Postal code is required",
    contactName: "Contact name is not valid",
    contactNumber: "Contact number is not valid",
    email: "Email is not valid",
    avgWeeklyOrders: "Average weekly orders is required"
  }
};

const errors = (inputName, inputValue, key) => {
  if (inputName === "firstName") {
    if (!inputValue || inputValue.length < 1) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "lastName") {
    if (!inputValue || inputValue.length < 1) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "mobileNumber") {
    if (!inputValue || inputValue.length <= 3) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "password") {
    if (!inputValue || inputValue.length < 6) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "confirmPassword") {
    if (!inputValue || inputValue.length < 6) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "email") {
    if (!inputValue || !emailRegex(inputValue)) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "holderName") {
    if (!inputValue || inputValue.length < 3) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "currentPassword") {
    if (!inputValue || inputValue.length < 6) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "newPassword") {
    if (!inputValue || inputValue.length < 6) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "number") {
    if (!inputValue || inputValue.length !== 16) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "expYear") {
    const parsedInt = parseInt(inputValue);
    if (!inputValue || parsedInt < 2018 || parsedInt > 2030) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "expMonth") {
    const parsedInt = parseInt(inputValue);
    if (!inputValue || parsedInt < 1 || parsedInt > 12) {
      return formErrorsMessage[key][inputName];
    }
  }
  if (inputName === "cvv2") {
    if (!inputValue || inputValue.length < 2 || inputValue.length > 4) {
      return formErrorsMessage[key][inputName];
    }
  }

  if (inputName === "postalCode") {
    if (!inputValue) {
      return formErrorsMessage[key][inputName];
    }
  }

  if (inputName === "restaurantName") {
    if (!inputValue || inputValue.length < 4) {
      return formErrorsMessage[key][inputName];
    }
  }

  if (inputName === "contactName") {
    if (!inputValue || inputValue.length < 4) {
      return formErrorsMessage[key][inputName];
    }
  }

  if (inputName === "contactNumber") {
    if (!inputValue || inputValue.length < 6) {
      return formErrorsMessage[key][inputName];
    }
  }

  if (inputName === "avgWeeklyOrders") {
    if (!inputValue) {
      return formErrorsMessage[key][inputName];
    }
  }

  if (inputName === "addressLine1") {
    if (!inputValue) {
      return formErrorsMessage[key][inputName];
    }
  }

  if (inputName === "flatNumber") {
    if (!inputValue) {
      return formErrorsMessage[key][inputName];
    }
  }
};

const validateForms = (states, key) => {
  const formData = states;
  let error;
  for (let inputName in formData) {
    error = errors(inputName, formData[inputName], key);
  }
  return error;
};

export default validateForms;
